import { Modal } from '@/components/ui/Modal/Modal';
import { EmailBodyPreview } from './EmailBodyPreview';
import './EmailPreviewModal.css';

export interface EmailPreviewModalProps {
  open: boolean;
  onClose: () => void;
  html: string;
  loading?: boolean;
}

export function EmailPreviewModal({ open, onClose, html, loading }: EmailPreviewModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title=""
      size="lg"
      headerMode="close-only"
      contentAriaLabel="Предпросмотр письма"
      scrollableBody={false}
      className="email-preview-modal"
    >
      <EmailBodyPreview html={html} loading={loading} fitHeightToContent contentMaxVh={90} />
    </Modal>
  );
}
